import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_0ee3d37e from 'nuxt_plugin_sentryserver_0ee3d37e' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_adab3c14 from 'nuxt_plugin_sentryclient_adab3c14' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_bootstrapvue_440af1e9 from 'nuxt_plugin_bootstrapvue_440af1e9' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_workbox_13625c56 from 'nuxt_plugin_workbox_13625c56' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_moment_affa49c4 from 'nuxt_plugin_moment_affa49c4' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_15766dba from 'nuxt_plugin_axios_15766dba' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_0c6949e0 from 'nuxt_plugin_gtm_0c6949e0' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginseo_3b204956 from 'nuxt_plugin_pluginseo_3b204956' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_3eeae668 from 'nuxt_plugin_pluginrouting_3eeae668' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_271a7223 from 'nuxt_plugin_pluginmain_271a7223' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_onesignal_4de80622 from 'nuxt_plugin_onesignal_4de80622' // Source: ./onesignal.js (mode: 'client')
import nuxt_plugin_datepicker_269120f2 from 'nuxt_plugin_datepicker_269120f2' // Source: ../plugins/datepicker.client (mode: 'client')
import nuxt_plugin_timepicker_e2375270 from 'nuxt_plugin_timepicker_e2375270' // Source: ../plugins/timepicker.client (mode: 'client')
import nuxt_plugin_general_767f1087 from 'nuxt_plugin_general_767f1087' // Source: ../plugins/general.client (mode: 'client')
import nuxt_plugin_freshchat_3d97e0a9 from 'nuxt_plugin_freshchat_3d97e0a9' // Source: ../plugins/freshchat.client (mode: 'client')
import nuxt_plugin_modal_537166bc from 'nuxt_plugin_modal_537166bc' // Source: ../plugins/modal.client (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_localize_1e22391a from 'nuxt_plugin_localize_1e22391a' // Source: ../plugins/localize.client (mode: 'client')
import nuxt_plugin_oneSignal_6c4436fe from 'nuxt_plugin_oneSignal_6c4436fe' // Source: ../plugins/oneSignal.client (mode: 'client')
import nuxt_plugin_toast_49c09830 from 'nuxt_plugin_toast_49c09830' // Source: ../plugins/toast.client (mode: 'client')
import nuxt_plugin_helper_7bacde55 from 'nuxt_plugin_helper_7bacde55' // Source: ../plugins/helper.client (mode: 'client')
import nuxt_plugin_analytics_7c318aa9 from 'nuxt_plugin_analytics_7c318aa9' // Source: ../plugins/analytics.client (mode: 'client')
import nuxt_plugin_lazyload_7cd228ae from 'nuxt_plugin_lazyload_7cd228ae' // Source: ../plugins/lazyload.client (mode: 'client')
import nuxt_plugin_functions_d87774d8 from 'nuxt_plugin_functions_d87774d8' // Source: ../functions (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Qoala - Cari Asuransi Tanpa Anjak Kaki","description":"Asuransi online yang siap melindungi kamu dan orang tersayang, di mana aja, kapan aja. Premi murah, proses klaim mudah, dan 100% digital!","keywords":"asuransi, digital, klaim, murah, di mana saja, kapan saja","meta":[{"hid":"description","name":"description","content":"Asuransi online yang siap melindungi kamu dan orang tersayang, di mana aja, kapan aja. Premi murah, proses klaim mudah, dan 100% digital!"},{"hid":"keywords","name":"keywords","content":"asuransi, digital, klaim, murah, di mana saja, kapan saja"},{"charset":"utf-8"},{"name":"viewport","content":"viewport-fit=cover, width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"hid":"description","name":"description","content":"Asuransi online yang siap melindungi kamu dan orang tersayang, di mana aja, kapan aja. Premi murah, proses klaim mudah, dan 100% digital!"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fqoala.app"},{"hid":"og:title","property":"og:title","content":"Qoala - Cari Asuransi Tanpa Anjak Kaki"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fqoala.app\u002Fimages\u002Fqoala-app-logo-min.png"},{"hid":"og:description","property":"og:description","content":"Asuransi online yang siap melindungi kamu dan orang tersayang, di mana aja, kapan aja. Premi murah, proses klaim mudah, dan 100% digital!"},{"itemprop":"name","content":"Qoala - Cari Asuransi Tanpa Anjak Kaki"},{"itemprop":"description","content":"Asuransi online yang siap melindungi kamu dan orang tersayang, di mana aja, kapan aja. Premi murah, proses klaim mudah, dan 100% digital!"},{"itemprop":"image","content":"https:\u002F\u002Fqoala.app\u002Fimages\u002Fqoala-app-logo-min.png"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Qoala"},{"hid":"author","name":"author","content":"Qoala Engineering"},{"hid":"theme-color","name":"theme-color","content":"#FF6A00"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Qoala"}],"noscript":[{"innerHTML":"Please allow your javascript browser","body":true},{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5SXTR4V&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"link":[{"rel":"preload","as":"font","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Lato&subset=latin,latin-ext","crossorigin":true},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ficons\u002F72.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Open+Sans:400,700&display=swap"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fbrella-640x1136.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fbrella-750x1294.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fbrella-1242x2148.png","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fbrella-1125x2436.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fbrella-1536x2048.png","media":"(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fbrella-1668x2224.png","media":"(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fbrella-2048x2732.png","media":"(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.1bcaf3fd.json"},{"rel":"shortcut icon","href":"\u002Ficons\u002F72.png"},{"rel":"apple-touch-icon","href":"\u002Ficons\u002F512.png","sizes":"512x512"}],"script":[{"src":"https:\u002F\u002Fwchat.freshchat.com\u002Fjs\u002Fwidget.js","async":"false","body":"true"},{"async":true,"src":"https:\u002F\u002Fcdn.onesignal.com\u002Fsdks\u002FOneSignalSDK.js","hid":"onesignal"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5SXTR4V')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_0ee3d37e === 'function') {
    await nuxt_plugin_sentryserver_0ee3d37e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_adab3c14 === 'function') {
    await nuxt_plugin_sentryclient_adab3c14(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_440af1e9 === 'function') {
    await nuxt_plugin_bootstrapvue_440af1e9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_13625c56 === 'function') {
    await nuxt_plugin_workbox_13625c56(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_affa49c4 === 'function') {
    await nuxt_plugin_moment_affa49c4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_15766dba === 'function') {
    await nuxt_plugin_axios_15766dba(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_0c6949e0 === 'function') {
    await nuxt_plugin_gtm_0c6949e0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_3b204956 === 'function') {
    await nuxt_plugin_pluginseo_3b204956(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3eeae668 === 'function') {
    await nuxt_plugin_pluginrouting_3eeae668(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_271a7223 === 'function') {
    await nuxt_plugin_pluginmain_271a7223(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onesignal_4de80622 === 'function') {
    await nuxt_plugin_onesignal_4de80622(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_269120f2 === 'function') {
    await nuxt_plugin_datepicker_269120f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_timepicker_e2375270 === 'function') {
    await nuxt_plugin_timepicker_e2375270(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_general_767f1087 === 'function') {
    await nuxt_plugin_general_767f1087(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_freshchat_3d97e0a9 === 'function') {
    await nuxt_plugin_freshchat_3d97e0a9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modal_537166bc === 'function') {
    await nuxt_plugin_modal_537166bc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localize_1e22391a === 'function') {
    await nuxt_plugin_localize_1e22391a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_oneSignal_6c4436fe === 'function') {
    await nuxt_plugin_oneSignal_6c4436fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_49c09830 === 'function') {
    await nuxt_plugin_toast_49c09830(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_helper_7bacde55 === 'function') {
    await nuxt_plugin_helper_7bacde55(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_7c318aa9 === 'function') {
    await nuxt_plugin_analytics_7c318aa9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyload_7cd228ae === 'function') {
    await nuxt_plugin_lazyload_7cd228ae(app.context, inject)
  }

  if (typeof nuxt_plugin_functions_d87774d8 === 'function') {
    await nuxt_plugin_functions_d87774d8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
